import { QueryKey } from 'react-query';

export const queryKeys = {
  all: ['appointment'],
  byId: (payload: { id: string }): QueryKey => [...queryKeys.all, payload.id],
};
